import React, { memo, useState, useEffect } from "react";

import RotuloSeplag from "../../components/RotuloSeplag";

import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
import { InputMask } from 'primereact/inputmask';
import { Button } from "primereact/button";
import { orgaoService, tipoAtoService } from "../../service/certidao";
import { pesquisarAll } from "../../service/EsferaGoverno";

const FiltroComponent = (props) => {

    const [filtro, setFiltro] = useState({
        tipo: null,
        identificador: '',
        data: '',
        orgao: null,
        esfera: null
    });

    const [tipoAto, setTipoAto] = useState([])
    const [orgao, setOrgao] = useState([])
    const [esferaGoverno, setEsferaGoverno] = useState([])


    const buscar = () => {

        let filtroBodyRequest = {
            idenTipoAto: filtro.tipo ? filtro.tipo.idenTipoAto : null,
            dataPublicacaoAto: filtro.data ? filtro.data : '',
            numrAto: filtro.identificador ? filtro.identificador : '',
            idenEsferaGoverno: filtro.esfera ? filtro.esfera.idenEsferaGoverno : null,
            orgao: filtro.orgao ? { idenOrgao: filtro.orgao.idenOrgao } : { idenOrgao: null }
        }

        props.buscar(filtroBodyRequest)

    }

    useEffect(() => {
        orgaoService().then((res) => {
            setOrgao(res)
        });
        tipoAtoService().then((res2) => {
            setTipoAto(res2)
        });
        pesquisarAll().then((res3) => {
            setEsferaGoverno(res3)
        });

    }, []);

    return (
        <>
            <RotuloSeplag nome="Amparo Legal:" cols="12 3" >
                <Dropdown className="campoTamanhoCompleto" value={filtro.tipo} options={tipoAto} emptyFilterMessage='Não Foi Encontrado o Ato' optionLabel="descTipoAto" onChange={(e) => setFiltro({ ...filtro, tipo: e.value })} placeholder="Selecione.." filter resetFilterOnHide showClear />
            </RotuloSeplag>

            <RotuloSeplag nome="Número do Ato:" cols="12 3" >
                <InputText value={filtro.identificador} onChange={(e) => setFiltro({ ...filtro, identificador: e.target.value })} />
            </RotuloSeplag>

            <RotuloSeplag nome="Data do Ato:" cols="12 3" >
                <InputMask value={filtro.data} mask="99/99/9999" onChange={(e) => setFiltro({ ...filtro, data: e.value })} />
            </RotuloSeplag>

            <RotuloSeplag nome="Órgão:" cols="12 3" >
                <Dropdown className="campoTamanhoCompleto" value={filtro.orgao} options={orgao} optionLabel="descOrgao" onChange={(e) => setFiltro({ ...filtro, orgao: e.value })} placeholder="Selecione.." filter resetFilterOnHide showClear />
            </RotuloSeplag>


            {/* <RotuloSeplag nome="Complemento:" cols="12 4" >
                <InputText value={filtro.identificador} onChange={(e) => setFiltro({ ...filtro, identificador: e.target.value })} />
            </RotuloSeplag> */}

            <RotuloSeplag nome="Esfera:" cols="12 3" >
                <Dropdown className="campoTamanhoCompleto" value={filtro.esfera} options={esferaGoverno} emptyFilterMessage='Não Foi Encontrada a Esfera' optionLabel="descEsferaGoverno" onChange={(e) => setFiltro({ ...filtro, esfera: e.value })} placeholder="Selecione.." filter resetFilterOnHide showClear />
            </RotuloSeplag>


            <div className='p-col-12 p-md-1' style={{ alignSelf: 'end' }} >
                <Button type="button" style={{ width: '100%' }} icon="pi pi-search" onClick={buscar} />
            </div>
        </>
    )
}

export default memo(FiltroComponent)